import { render, staticRenderFns } from "./VUserApi.vue?vue&type=template&id=36e5058e&"
import script from "./VUserApi.vue?vue&type=script&lang=js&"
export * from "./VUserApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports